import { eq } from '@tanstack/db'
import { useLiveQuery } from '@tanstack/react-db'
import { useStore } from '@/lib/pocketbase'
import type { Jobs } from '@/types/pbSchema'

interface UseCustomerJobsOptions {
    customerId: string | undefined
    enabled?: boolean
}

export function useCustomerJobs({ customerId, enabled = true }: UseCustomerJobsOptions) {
    const [jobsCollection] = useStore('jobs')

    const { isLoading, data: jobs = [] } = useLiveQuery(
        q =>
            customerId && enabled
                ? q
                      .from({ jobs: jobsCollection })
                      .where(({ jobs }) => eq(jobs.customer, customerId))
                      .orderBy(({ jobs }) => jobs.created, 'desc')
                : undefined,
        [customerId, enabled]
    )

    return {
        jobs: jobs as Jobs[],
        isLoading,
    }
}
